import Auth from '@ublend-npm/aula-auth-client';
import leaveSSA from '$utils/leaveSSA';

// eslint-disable-next-line import/prefer-default-export
export const handleLogout =
  ({ user, institution }) =>
  async () => {
    const { email } = user;

    await Auth.requestLogout(email, institution)
      .catch(() => null)
      .finally(() => {
        leaveSSA();
      });
  };
